import { Component, Vue } from 'vue-property-decorator';

import { HeroCarouselDerBlockViewModel } from './HeroCarouselDerModule.types';
import { getComponentProps } from '@/utils/vueUtils';

import ImageVideoGallery from '@/components/ImageVideoGallery/ImageVideoGallery.vue';
import PhotographyInfoComponent from '@/components/PhotographyInfoComponent/PhotographyInfoComponent.vue';
import { getResizeImage } from '@/utils/commonUtils';
import ResponsiveImage from '@/components/ResponsiveImage/ResponsiveImage.vue';
import Rectangles from '@/assets/icons/rectangles.svg?inline';
import { ImageSizes, ImageSize } from '@/common/interfaces/SizeBreakpoints';

const HeroCarouselDerModuleProps = Vue.extend({
  props: getComponentProps<HeroCarouselDerBlockViewModel>({
    Image: { Url: getResizeImage('penguins-group.jpg'), Alt: 'Hike' },
    PhotographyInfo: {
      Photographer: {
        PhotographerName: 'Robert Swan',
        PhotographerTitle: 'Guest',
        PhotoDate: 'May 2018',
        PhotographerImage: {
          Url: getResizeImage('photographer.jpg'),
          Alt: 'Photographer',
        },
      },
      Exposure: {
        Speed: 'F/8',
        Aperture: '1/800',
        Iso: 'ISO 400',
      },
    },
    Gallery: {
      Slides: [
        {
          Image: { Url: '#', Alt: '#' },
          Video: {
            Type: 'video/youtube',
            Url: 'https://www.youtube.com/watch?v=2x24IDoIT40',
            Poster: getResizeImage('diving.jpg'),
          },
          Caption: '',
          Photographer: {
            PhotographerName: 'Robert Swan',
            PhotographerTitle: 'Guest',
            PhotoDate: 'May 2018',
          },
        },
      ],
      ShareData: {
        Url: 'https://d3t9z7c45vc1rg.cloudfront.net/',
        Title: '10 Tips for Better Expedition Photos',
        Description:
          'Grosvenor Teacher Fellow Cristina Veresan shares the photo lessons she learned while on expedition in Svalbard.',
        Hashtags: 'article,travel,lindblad',
        Quote: 'Lindblad article - facebook',
        TwitterUser: 'LindbladExp',
      },
    },
  }),
});

@Component({
  components: {
    ImageVideoGallery,
    ResponsiveImage,
    PhotographyInfo: PhotographyInfoComponent,
    Rectangles,
  },
})
export default class HeroCarouselDerModule extends HeroCarouselDerModuleProps {
  imageSizes: ImageSizes = {
    def: new ImageSize([1920, 1080]),
    sizes: {
      sm: new ImageSize([768, 1024]),
      md: new ImageSize([992, 744]),
      lg: new ImageSize([1199, 900]),
      xl: new ImageSize([1920, 1080]),
    },
  };
}
